import { Directive, Attribute, forwardRef } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

@Directive({
  selector: '[step][ngModel]',
  providers: [
    // tslint:disable-next-line:no-forward-ref
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => JbStepValidator), multi: true}
  ]
})
export class JbStepValidator {
  /* tslint:disable */
  constructor(@Attribute('step') public step: number) {
    /* tslint:enable */
  }

  private decimalPlaces(num) {
    const match = ('' + num).match(/(?:\.(\d+))?$/);
    if (!match) {
      return 0;
    }

    // Number of digits right of decimal point.
    return match[1] ? match[1].length : 0;
  }

  private toInt(num, decimals) {
    return Math.round(num * Math.pow(10, decimals));
  }

  public validate(c: FormControl): { [key: string]: any } {
    const decimals = this.decimalPlaces(this.step);

    let valid: boolean = true;

    // Value can't have too many decimals
    if (
      this.decimalPlaces(c.value) > decimals ||
      this.toInt(c.value, decimals) % this.toInt(this.step, decimals) !== 0
    ) {
      valid = false;
    }

    return valid ? null : {
      step: {
        valid: false
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/form/validators/step.validator.ts